import {forwardRef} from 'react';
import {Link} from 'react-router-dom';

type Props = {
	href: string;
}

const RouterLink = forwardRef(({href, ...other}: Props, ref: any) => <Link ref={ref} to={href} {...other} />);

export default RouterLink;